const ArrowIcon = ({ isActive }) => {
  return (
    <svg
    className="arrow-icon"
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.7071 17.2071C30.0976 16.8166 30.0976 16.1834 29.7071 15.7929L23.3431 9.42893C22.9526 9.03841 22.3195 9.03841 21.9289 9.42893C21.5384 9.81946 21.5384 10.4526 21.9289 10.8431L27.5858 16.5L21.9289 22.1569C21.5384 22.5474 21.5384 23.1805 21.9289 23.5711C22.3195 23.9616 22.9526 23.9616 23.3431 23.5711L29.7071 17.2071ZM3 17.5L29 17.5L29 15.5L3 15.5L3 17.5Z"
        fill={isActive ? "#C4C4C4" : "black"}
      />
    </svg>
  );
};

export default ArrowIcon;
